import { Link } from "react-router-dom";
import { useState } from "react";
import { blogArticles } from "@/mocks/home";

const blogImages: Record<string, string> = {
  "blog-v2-01-main": "https://readdy.ai/api/search-image?query=Modern%20clean%20workspace%20with%20large%20monitor%20displaying%20spreadsheet%20data%20and%20product%20images%20white%20minimalist%20desk%20natural%20daylight%20bright%20airy%20office%20professional%20atmosphere%20soft%20shadows%20editorial%20photography%20warm%20neutral%20background%20high%20detail&width=600&height=400&seq=blogthumb-v2-01-main&orientation=landscape",
  "blog-v2-02-tutorial": "https://readdy.ai/api/search-image?query=Step%20by%20step%20guide%20showing%20hands%20using%20laptop%20with%20spreadsheet%20interface%20on%20clean%20white%20desk%20bright%20natural%20workspace%20minimalist%20modern%20editorial%20photography%20warm%20neutral%20tones&width=600&height=400&seq=blogthumb-v2-02-tutorial&orientation=landscape",
  "blog-v2-03-safety": "https://readdy.ai/api/search-image?query=Security%20and%20trust%20concept%20with%20magnifying%20glass%20over%20product%20package%20on%20clean%20white%20desk%20bright%20studio%20lighting%20minimalist%20editorial%20photography%20professional%20aesthetic&width=600&height=400&seq=blogthumb-v2-03-safety&orientation=landscape",
  "blog-v2-04-shipping": "https://readdy.ai/api/search-image?query=Shipping%20boxes%20and%20packages%20arranged%20neatly%20on%20clean%20white%20surface%20with%20world%20map%20concept%20bright%20studio%20lighting%20minimalist%20editorial%20product%20photography&width=600&height=400&seq=blogthumb-v2-04-shipping&orientation=landscape",
  "blog-v2-05-vs": "https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20two%20shopping%20carts%20side%20by%20side%20on%20clean%20modern%20desk%20bright%20natural%20light%20minimalist%20editorial%20photography%20warm%20neutral%20background&width=600&height=400&seq=blogthumb-v2-05-vs&orientation=landscape",
  "blog-v2-06-sneakers": "https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20sneakers%20displayed%20artistically%20on%20clean%20white%20surface%20bright%20studio%20lighting%20minimalist%20editorial%20product%20photography%20professional%20aesthetic%20high%20detail&width=600&height=400&seq=blogthumb-v2-06-sneakers&orientation=landscape",
  "blog-v2-07-qc": "https://readdy.ai/api/search-image?query=Close%20up%20detailed%20inspection%20of%20clothing%20item%20with%20measuring%20tape%20on%20clean%20white%20desk%20bright%20studio%20lighting%20minimalist%20editorial%20photography%20quality%20control%20theme&width=600&height=400&seq=blogthumb-v2-07-qc&orientation=landscape",
  "blog-v2-08-haul": "https://readdy.ai/api/search-image?query=Organized%20shopping%20haul%20with%20various%20fashion%20items%20laid%20out%20on%20clean%20white%20surface%20bright%20natural%20daylight%20minimalist%20editorial%20product%20photography%20warm%20neutral%20tones&width=600&height=400&seq=blogthumb-v2-08-haul&orientation=landscape",
  "blog-v2-09-alternatives": "https://readdy.ai/api/search-image?query=Multiple%20shopping%20bags%20with%20world%20map%20concept%20on%20clean%20modern%20desk%20bright%20natural%20lighting%20minimalist%20editorial%20photography%20warm%20neutral%20background%20professional&width=600&height=400&seq=blogthumb-v2-09-alternatives&orientation=landscape",
  "blog-v2-10-reddit": "https://readdy.ai/api/search-image?query=Online%20community%20discussion%20concept%20with%20laptop%20showing%20forum%20interface%20on%20clean%20bright%20workspace%20minimalist%20modern%20editorial%20photography%20natural%20lighting&width=600&height=400&seq=blogthumb-v2-10-reddit&orientation=landscape",
  "blog-v2-11-save": "https://readdy.ai/api/search-image?query=Money%20saving%20concept%20with%20calculator%20and%20shipping%20label%20on%20clean%20white%20desk%20bright%20natural%20lighting%20minimalist%20editorial%20photography%20warm%20neutral%20background&width=600&height=400&seq=blogthumb-v2-11-save&orientation=landscape",
  "blog-v2-12-beginner": "https://readdy.ai/api/search-image?query=Beginner%20friendly%20guide%20concept%20with%20open%20notebook%20and%20laptop%20on%20clean%20white%20desk%20bright%20warm%20natural%20light%20minimalist%20editorial%20photography%20inviting%20atmosphere&width=600&height=400&seq=blogthumb-v2-12-beginner&orientation=landscape",
};

const ITEMS_PER_PAGE = 6;

export default function BlogPreview() {
  const [showAll, setShowAll] = useState(false);
  const displayedArticles = showAll ? blogArticles : blogArticles.slice(0, ITEMS_PER_PAGE);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
            Latest Content
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
            Latest Buying<br />
            Guides &amp; Reviews
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl">
            Expert guides, comparisons, and tips to help you master international shopping with Superbuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          {displayedArticles.map((article) => (
            <Link
              key={article.id}
              to={`/blog/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={blogImages[article.imageSeq] || blogImages["blog-v2-01-main"]}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{article.excerpt}</p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-accent-600 group-hover:text-accent-700 transition-colors">
                  Read Article
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {!showAll && blogArticles.length > ITEMS_PER_PAGE && (
          <div className="mt-8 text-center">
            <button
              onClick={() => setShowAll(true)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 border border-foreground-200 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap"
            >
              View All {blogArticles.length} Articles
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-line"></i>
              </span>
            </button>
          </div>
        )}

        {showAll && blogArticles.length > ITEMS_PER_PAGE && (
          <div className="mt-8 text-center">
            <button
              onClick={() => setShowAll(false)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 border border-foreground-200 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap"
            >
              Show Less
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-up-line"></i>
              </span>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}